import authApi from '@/api/auth'

// initial state
const state = {
  userEmailByPasswordResetToken: ''
}

// getters
const getters = {
  getUserEmailByPasswordResetToken: state => state.userEmailByPasswordResetToken
}

// actions
const actions = {
  async getUserEmailByPasswordResetToken ({ commit, state }, payload) {
    const response = await authApi.getUserEmailByPasswordResetToken(payload)
    if (!response.body || !response.body.email) {
      return
    }

    commit('SET_USER_EMAIL_BY_PASSWORD_RESET_TOKEN', response.body.email)
  }
}

// mutations
const mutations = {
  SET_USER_EMAIL_BY_PASSWORD_RESET_TOKEN (state, payload) {
    state.userEmailByPasswordResetToken = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/auth.js